import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { memo, type ReactNode } from "react";
import * as styles from "./disputes.module.css";
import { RECLAIM_IMAGE_URL } from "./reclaim-constants";

/**
 * Modal with hero image header, backdrop blur, and white card body.
 * Copied line-for-line from the admin onboarding modal pattern.
 * Reusable across any product.
 */
export const HeroModal = memo(function HeroModal({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  footer,
  headerImageUrl = RECLAIM_IMAGE_URL,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
  headerImageUrl?: string;
}) {
  return (
    <RedoModal
      hideFooter
      hideHeader
      isOpen={isOpen}
      modalSize="sm"
      muiClassName={styles.backdropBlur}
      noPadding
      onModalCloseRequested={onClose}
      title={title}
    >
      <div className={styles.modalImageWrapper}>
        <img alt="" className={styles.modalHeaderImage} src={headerImageUrl} />
        <div className={styles.modalImageOverlay} />
        <div className={styles.modalImageLabel}>
          <span className={styles.modalImageTitle}>{title}</span>
          {subtitle && <p className={styles.modalImageSubtitle}>{subtitle}</p>}
        </div>
      </div>

      <Flex className={styles.modalContentBody} dir="column">
        {children}
      </Flex>

      {footer && <Flex className={styles.modalStickyFooter}>{footer}</Flex>}
    </RedoModal>
  );
});
